import React from "react";
import { useTranslation } from "react-i18next";
import { Divider, Paper, Stack, Typography } from "@mui/material";

import { useClient } from "../../contexts/ClientContext";
import ChangePasswordForm from "./ChangePasswordForm";

const getAccountName = (account) => account?.name || account?.clientId || "";

function ProfilePage() {
  const { t } = useTranslation();
  const { clientInfo, sessionWarningKey } = useClient();

  const email = clientInfo?.member?.email || t("common.noData");
  const accountName = getAccountName(clientInfo?.account) || t("common.noData");

  return (
    <Stack sx={{ p: 3, maxWidth: 720, mx: "auto", width: "100%" }} spacing={3}>
      <Paper elevation={1} sx={{ p: 3 }}>
        <Typography variant="h5" sx={{ mb: 1 }}>
          {t("auth.profileTitle")}
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          {t("auth.profileDescription")}
        </Typography>

        {sessionWarningKey ? (
          <Typography color="warning.main" sx={{ mb: 2 }}>
            {t(sessionWarningKey)}
          </Typography>
        ) : null}

        <Stack spacing={2}>
          <Stack spacing={0.5}>
            <Typography variant="caption" color="text.secondary">
              {t("auth.emailLabel")}
            </Typography>
            <Typography variant="body1">{email}</Typography>
          </Stack>

          <Stack spacing={0.5}>
            <Typography variant="caption" color="text.secondary">
              {t("auth.accountNameLabel")}
            </Typography>
            <Typography variant="body1">{accountName}</Typography>
          </Stack>
        </Stack>
      </Paper>

      <Paper elevation={1} sx={{ p: 3 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          {t("auth.changePasswordTitle")}
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <ChangePasswordForm />
      </Paper>
    </Stack>
  );
}

export default ProfilePage;
